var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dm-empty',{attrs:{"scene":_vm.scene}})}
var staticRenderFns = []

export { render, staticRenderFns }